import { useCallback, useEffect, useState } from 'react'
import { Contract } from 'web3-eth-contract'

import { 
  getEarned, 
  getMasterChefContract, 
  getMasterChef2Contract,
  getEth2MasterContract, 
  getEth2MasterPendingToken,
  getAethMasterContract,
  getAethBakeBaseMasterPendingToken,
  getTokenEarned
} from '../../sushi/utils'
import { MINTTOKEN } from '../../constants/bakery'

// hooks
import useYam from './useYam'
import useBlock from './useBlock'
import { useActiveWeb3React } from '../'

const useEthEarnings = (lpTokenAddress: string, tokenName?: string) => {
  const [balance, setBalance] = useState<any>()
  const {account} = useActiveWeb3React()
  const yam = useYam()
  const block = useBlock()
  let masterContract: Contract
  let getEarn: any
  switch (tokenName) {
    case MINTTOKEN.ETH2MASTER:
      masterContract = getEth2MasterContract(yam)
      getEarn = getEth2MasterPendingToken
      break
    case MINTTOKEN.AETHMASTER:
      masterContract = getAethMasterContract(yam)
      getEarn = getAethBakeBaseMasterPendingToken
      break
    case MINTTOKEN.BAKEV2:
      masterContract = getMasterChef2Contract(yam)
      getEarn = getTokenEarned
      break
    default:
      masterContract = getMasterChefContract(yam)
      getEarn = getEarned
  }

  const fetchBalance = useCallback(async () => {
    const balance = await getEarn(masterContract, lpTokenAddress, account)
    switch (tokenName) {
      case MINTTOKEN.ETH2MASTER:
        balance.tokenReward = balance.bethReward
        balance.tokenRewardNow = balance.bethRewardNow
        break
      case MINTTOKEN.AETHMASTER:
        balance.ankrReward = balance.otherRewards[0]
        balance.ankrRewardNow = balance.nowOtherRewards[0]
        balance.ankrConvertToBakeRewards = balance.otherConvertToBakeRewards[0]

        balance.onxReward = balance.otherRewards[1]
        balance.onxRewardNow = balance.nowOtherRewards[1]
        balance.onxConvertToBakeRewards = balance.otherConvertToBakeRewards[1]
        break
    }
    setBalance(balance)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, masterContract, yam])

  useEffect(() => {
    if (account && masterContract && yam) {
      fetchBalance()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, block, masterContract, setBalance, yam])

  return balance
}

export default useEthEarnings
